import { render, staticRenderFns } from "./o-tiles.vue?vue&type=template&id=c0f09b02&"
import script from "./o-tiles.vue?vue&type=script&lang=js&"
export * from "./o-tiles.vue?vue&type=script&lang=js&"
import style0 from "./o-tiles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports